const Theme = localStorage.getItem('Theme');

export default [
  {
    path: '/organization',
    component: () => import(/* webpackChunkName: "organization" */`@/modules/FPKG-10000-Theme/layout/${Theme === null ? 'DEFAULT' : Theme}/index.vue`),
    children: [
      // 部門
      {
        path: 'department/info',
        name: 'organization-department-info',
        component: () => import(/* webpackChunkName: "organization" */'@/modules/FPKG-60000-Organization/department/info.vue'),
        meta: {
          title: 'NODE_6',
          url: 'organization/department/info',
          toolbar: ['create'],
        },
      },
      // 職務
      {
        path: 'department-position/info',
        name: 'department-position-info',
        component: () => import(/* webpackChunkName: "organization" */'@/modules/FPKG-60000-Organization/department-position/info.vue'),
        meta: {
          title: 'NODE_6',
          url: 'organization/department/info',
          toolbar: ['create'],
        },
      },
      // 帳號
      {
        path: 'department-account/info',
        name: 'department-account-info',
        component: () => import(/* webpackChunkName: "organization" */'@/modules/FPKG-60000-Organization/department-account/info.vue'),
        meta: {
          title: 'NODE_6',
          url: 'organization/department/info',
          toolbar: ['save'],
        },
      },

    ],
  },
];
